<template>
	<div class="about-xs" style="position:relative;">

		<div class="aw-register-box about-box">
			<div class="mod-body clearfix gxgd">
				<div class="content   aboutx">
					<h1 style="color: #2d8cf0;">5.1、常用函数</h1>
					<div class="about-t">


						&nbsp; &nbsp;&nbsp; &nbsp; 函数这里只介绍几种最常用的函数sysdate(),count(),sum(),avg(),max(),min()
						。更多的函数查看后面提供的网址自己去学习。讲解函数前咱们先创建商品销售记录表，并向改表里插入一下数据方便咱们后面展示函数的使用。<br />

						环境准备：
						<sql-show :value="sqlInfo1"> </sql-show>
						注：如果表已存在先执行 drop table SALE_PRODUCT_T 删除表。</br>
						<sql-show :value="sqlInfo2"> </sql-show>
						查看数据
						<sql-show value="select * from SALE_PRODUCT_T ;"> </sql-show>
						<img style="width: auto;" :src="require('../../assets/sql/select20.png')"> </br>
						<div style="padding-left: 50px;">
							<img style="width: 40px;" :src="require('../../assets/image/jiantou.png')">
							<a @click="toRunSql">打开我的在线sql学习编辑器 </a></br>
						</div>

						<h2 class="about-little">(1) sysdate()当前日期函数</font>
						</h2>
						<sql-show value="select sysdate() from SALE_PRODUCT_T;"> </sql-show>
						<sql-show value="select sysdate();"> </sql-show>
						<img style="width: auto;" :src="require('../../assets/sql/select18.png')"> </br>
						注：第一个语句因为SALE_PRODUCT_T表里有7条数据所以有7条当前时间，第二个语句只有一个。

						<h2 class="about-little">(2) count()当前表中数据总条数</font>
						</h2>
						含义：查看表里有多少条数据,比如菜老板想看看最近发生了多少笔交易。
						<sql-show value="select  count(*) from  SALE_PRODUCT_T;"> </sql-show>
						<img style="width: auto;" :src="require('../../assets/sql/select19.png')"> </br>
						注：表里有7条数据，所以最近菜老板的商店发生了7笔交易。

						<h2 class="about-little">(3) sum()求和</font>
						</h2>
						含义：总数，比如菜老板想看看最近商店卖了多少钱。
						语句一：
						<sql-show value="select  sum(SALE_PRICE) from  SALE_PRODUCT_T ;"> </sql-show>
						<img style="width: auto;" :src="require('../../assets/sql/select21.png')"> </br>
						注：这个数对不对？好像不对这是把单价做了求和，还有每笔交易的数量因素没考虑进去。
						语句二：
						<sql-show value="select  sum(SALE_PRICE*SALE_NUM) from  SALE_PRODUCT_T ;"> </sql-show>
						<img style="width: auto;" :src="require('../../assets/sql/select22.png')"> </br>
						注：这个结果对了，*代表乘法的意思

						<h2 class="about-little">(4) avg ()平均数</font>
						</h2>
						含义：返回数值列的平均值。比如菜老板卖的商品随着进货价的变动，他的卖价也会有波动，他想查看晨光中性笔的平均售价是多少，就可以用到平均值函数。

						目标：查看商品编号为NO001的商品售出商品的平均价格
						语句一：
						<sql-show value="select  avg(SALE_PRICE) from  SALE_PRODUCT_T where PRODUCT_NO='NO001' ;">
						</sql-show>
						<img style="width: auto;" :src="require('../../assets/sql/select23.png')"> </br>
						注：这个值还是不对啊！不是最终的结果，这个值只是将单价算了平均值，也没有考虑商品销售数量的问题。
						语句二：
						<sql-show
							value="select  sum(SALE_PRICE*SALE_NUM)/sum(SALE_NUM) from  SALE_PRODUCT_T where PRODUCT_NO='NO001' ;">
						</sql-show>
						<img style="width: auto;" :src="require('../../assets/sql/select24.png')"> </br>
						注：这个结果对了，“/”是除法的意思，这个算法也说明函数可以组合使用。

						<h2 class="about-little">(5) max()最大值</font>
						</h2>
						含义：返回数值列的最大值。比如菜老板想知道最近买的最贵的单价商品是多少钱。
						<sql-show value="select  max(SALE_PRICE)  from  SALE_PRODUCT_T ;"> </sql-show>
						<img style="width: auto;" :src="require('../../assets/sql/select25.png')"> </br>

						<h2 class="about-little">(6) min()最小值</font>
						</h2>
						含义：回数值列的最小值。比如菜老板想知道最近买的最便宜的单价商品是多少钱。
						<sql-show value="select  min(SALE_PRICE)  from  SALE_PRODUCT_T  ;"> </sql-show>
						<img style="width: auto;" :src="require('../../assets/sql/select26.png')"> </br>
					</div>
					<div>
						<Modal v-model="modal1" title="购买服务" @on-cancel="cancel">
							<Form :label-width="150">
								<Row>
									<Col align="center" :span="24">
									<div style="font-size: 50px;">微信支付</div>
									<div style="font-size: 22px;">在线sql学习服务<span style="color: red;">20元，有效期一个月</span>
									</div>
									<div ref="twoImageRef" id="twoImageId"></div>
									<div></div>
									<div style="font-size: 22px;">在线sql学习服务<span style="color: red;">100元，有效期一年</span>
									</div>
									<div ref="twoImageYearRef" id="twoImageIdYear"></div>
									</Col>
								</Row>
							</Form>
							<!-- 这里去掉确认和取消按钮 -->
							<div slot="footer"></div>
						</Modal>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
	import ChangeKeyWord from '@/components/project/ChangeKeyWord.vue'
	import QRCode from 'qrcodejs2'
	import {
		getIfPay,
		createTwoImage
	} from '@/network/index.js';
	import SqlShow from '@/components/project/SqlShow.vue'
	export default {
		components: {
			ChangeKeyWord,
			SqlShow,
		},

		data() {
			return {
				userId: '',
				ifLogin: false,
				ifMoney: 0,
				modal1: false,
				sqlInfo1: ' CREATE TABLE  SALE_PRODUCT_T( \r\n' +
					'   SALE_ID  		   	INT  		 	AUTO_INCREMENT   COMMENT  \'唯一编码\',\r\n' +
					'   PRODUCT_NO  			 VARCHAR(100) 	 NOT NULL      COMMENT  \'商品编号\',\r\n' +
					'   PRODUCT_NAME  		 VARCHAR(200) 	 NOT NULL      COMMENT  \'商品名称\',  \r\n' +
					'   SALE_NUM 	   		INT			   NOT NULL	     COMMENT  \'销售数量\',  \r\n' +
					'   SALE_TIME  			 DATETIME 		 NOT NULL      COMMENT  \'销售时间\',  \r\n' +
					'   SALE_PRICE   		DECIMAL(10,2)  NOT NULL      COMMENT  \'进货价格\',   \r\n' +
					'   PRIMARY KEY (SALE_ID)  \r\n' +
					' )ENGINE=INNODB DEFAULT CHARSET=UTF8 COMMENT=\'销售信息表\' ;    ',
				sqlInfo2: '  INSERT INTO  SALE_PRODUCT_T   (PRODUCT_NO , PRODUCT_NAME,SALE_NUM 	,SALE_TIME  	,SALE_PRICE)  \r\n' +
					'    VALUES (  \'NO001\', \'晨光中性笔\', 1, \'2022/10/14 12:44:25\', 1.52);\r\n' +
					'  INSERT INTO  SALE_PRODUCT_T   (PRODUCT_NO , PRODUCT_NAME,SALE_NUM 	,SALE_TIME  	,SALE_PRICE)   \r\n' +
					'    VALUES (  \'NO001\', \'晨光中性笔\', 2, \'2022/10/15 12:44:25\', 1.8);\r\n' +
					'  INSERT INTO  SALE_PRODUCT_T   (PRODUCT_NO , PRODUCT_NAME,SALE_NUM 	,SALE_TIME  	,SALE_PRICE)   \r\n' +
					'   VALUES (  \'NO002\', \'蓝电中性笔\', 1, \'2022/10/13 13:01:20\', 1.4);\r\n' +
					'  INSERT INTO  SALE_PRODUCT_T   (PRODUCT_NO , PRODUCT_NAME,SALE_NUM 	,SALE_TIME  	,SALE_PRICE)   \r\n' +
					'    VALUES (  \'NO002\', \'蓝电中性笔\', 2, \'2022/10/14 06:44:10\', 1.4);\r\n' +
					'  INSERT INTO  SALE_PRODUCT_T   (PRODUCT_NO , PRODUCT_NAME,SALE_NUM 	,SALE_TIME  	,SALE_PRICE)   \r\n' +
					'    VALUES (  \'NO002\', \'蓝电中性笔\', 3, \'2022/10/15 21:30:25\', 1.4);\r\n' +
					'  INSERT INTO  SALE_PRODUCT_T   (PRODUCT_NO , PRODUCT_NAME,SALE_NUM 	,SALE_TIME  	,SALE_PRICE)   \r\n' +
					'     VALUES (  \'NO003\', \'笔记本晨光\', 3, \'2022/10/16 21:30:25\', 1.4);\r\n' +
					'  INSERT INTO  SALE_PRODUCT_T   (PRODUCT_NO , PRODUCT_NAME,SALE_NUM 	,SALE_TIME  	,SALE_PRICE)   \r\n' +
					'    VALUES (  \'NO004\', \'笔记本晨光品牌\', 3, \'2022/10/16 21:30:25\', 1.4);',

			}
		},

		mounted() {
			this.checkPayStatus()
		},

		created() {
			this.userId = this.$store.state.userInfo.userId;
			if (this.userId != undefined) {
				this.ifLogin = true;
			}
			console.log('userId:' + this.userId);
		},
		computed: {

		},
		methods: {

			checkPayStatus() {
				//付费校验
				if (this.ifLogin == true) {
					getIfPay().then(res => {
						// console.log(res);
						this.ifMoney = res.data.obj;
						if (this.ifMoney == 1) {
							//关闭弹出窗
							this.modal1 = false
						} else {
							setTimeout(() => {
								this.checkPayStatus() // 等待一段时间后再次调用checkPayStatus方法
							}, 1000)
						}
					})
				}

			},
			cancel() {
				this.modal1 = false
			},

			//生成二维码
			generateQRCode(classId, value) {
				new QRCode(document.querySelector(classId), {
					text: value,
					width: 180,
					height: 180,
					colorDark: "#000000",
					colorLight: "#ffffff",
					correctLevel: QRCode.CorrectLevel.H
				})
			},

			toRunSql() {
				//判断是否登录
				if (this.ifLogin == true) {
					getIfPay().then(res => {
						// console.log(res);
						this.ifMoney = res.data.obj;
						//有效期内
						if (this.ifMoney == 1) {
							let routeUrl = this.$router.resolve({
								path: '/run',
							})
							window.open(routeUrl.href, '_blank')

						} else {
							//生成收费的二维码
							let paramter = {
								attach: this.$store.state.userInfo.loginId,
								money: 20000,
								//money: 1,
							};

							//清空之前的二维码 否则会生成多个
							this.$refs.twoImageRef.innerHTML = '';
							createTwoImage(paramter).then(res => {
								this.twoImage = res.code_url;
								this.generateQRCode("#twoImageId", this.twoImage);
							}).catch(error => {});


							let paramterYear = {
								attach: this.$store.state.userInfo.loginId,
								money: 100000,
								//money: 2
							};

							//清空之前的二维码 否则会生成多个
							this.$refs.twoImageYearRef.innerHTML = '';
							createTwoImage(paramterYear).then(res => {
								this.twoImageYear = res.code_url;
								this.generateQRCode("#twoImageIdYear", this.twoImageYear);
							}).catch(error => {});

							//弹出对话框，要求付费
							this.modal1 = true
						}

					}).catch(error => {});

				} else {
					this.$router.push('/login');
				}
			},

		},

	}
</script>

<style lang="scss" scoped>
	//写上样式
	.keyWord {
		color: #0fbda0;
	}


	#vip {
		color: red;
	}

	.about-xs {
		margin-bottom: 20px;
		margin-top: 10px;
	}

	//标题字体
	.aw-register-box .mod-body .content h2.about-cs {
		padding-top: 10px;
		color: #2d8cf0;
		font-size: 24px;
		height: 50px;
		text-align: left;
		font-weight: bold;
	}

	//内容字体	
	.aw-register-box .mod-body .content .about-t {
		width: 1040px;
		height: auto;
		overflow: hidden;
		text-align: left;
		font-size: 18px;
		line-height: 60px;
	}


	.aw-register-box .mod-body .content .about-t .at-r {
		width: 596px;
		height: auto;
		float: right;
		text-align: center;
	}

	.aw-register-box .mod-body {
		padding: 10px 10px 10px 10px;
	}

	.aw-register-box .gxgd {
		padding: 10px 10px 10px 10px;
	}


	.about-box {
		width: 1170px;
		margin: 20px;
		background-color: #fff;
		border-radius: 0;
		-webkit-box-shadow: 0 0 4px rgba(0, 0, 0, .1);
		-moz-box-shadow: 0 0 4px rgba(0, 0, 0, .1);
		box-shadow: 0 0 4px rgba(0, 0, 0, .1);
	}




	.aw-register-box .mod-body .content .about-t .at-l {
		width: 442px;
		height: auto;
		padding-top: 80px;
		float: left;
		text-align: left;
	}

	.aw-register-box .mod-body .content .about-t .at-l2 {
		width: 496px;
		height: auto;
		float: left;
		text-align: center;
	}

	.aw-register-box .mod-body .content h2.about-cs font {
		color: #e37626;
		font-size: 24px;
	}

	.aw-register-box .mod-bodyx .content h2 {
		margin: 0 0 13px 0;
		color: #333;
		font-size: 18px;
	}

	.aw-register-box .mod-body .content h2.t-center {
		text-align: center;
	}

	.aw-register-box .mod-body .mod-bodyt h2.t-center {
		text-align: center;
	}

	h2.about-little {
		padding-top: 10px;
		color: #2d8cf0;
		font-size: 20px;
		height: 50px;
		text-align: left;
		font-weight: bold;
	}
</style>
